import { render } from "./ClientRecipients.vue?vue&type=template&id=1fedb2e6&scoped=true"
import script from "./ClientRecipients.vue?vue&type=script&lang=js"
export * from "./ClientRecipients.vue?vue&type=script&lang=js"

import "./ClientRecipients.vue?vue&type=style&index=0&id=1fedb2e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fedb2e6"]])

export default __exports__